import { api } from '../api/client';

import { API_ITEMS_URL, API_RECORD_CODES_URL } from '../utils';
import { learnRecord, learnResolved } from '../utils/recordCodes';

/**
 * Record codes — the `/<letter>/<code>` short URLs (utils/recordCodes.js).
 *
 * `resolveRecordCode(kind, code)` → `{ kind, code, id, collection_id }` for a
 * record the caller can read. The API answers every refusal, an unknown code
 * and a malformed one with the same 404 (keepr-api docs/SCHEMA.md § Record
 * codes), so the caller cannot tell "not yours" from "no such code" either.
 * The answer is remembered, so the address bar and every later link to the
 * record read short without asking again.
 */
export async function resolveRecordCode(kind, code) {
	const { data } = await api.get(`${API_RECORD_CODES_URL}/${encodeURIComponent(kind)}/${encodeURIComponent(code)}`);
	learnResolved(data);
	return data;
}

/**
 * `/i/<ObjectId>`: an item addressed by its id alone. Its collection is read
 * from the item itself (items move between collections), and its code is
 * learned on the way.
 */
export async function itemHome(itemId) {
	const { data } = await api.get(`${API_ITEMS_URL}/${encodeURIComponent(itemId)}`);
	learnRecord(data, 'i');
	return { kind: 'item', id: String(data._id), code: data.code || null, collection_id: String(data.collection_id) };
}
